module.exports = __webpack_public_path__ + "img/0x001ef4385d199454b76527fd91af3da8c0a51537.e1994969.png";